import { createGlobalStyle } from "styled-components";

export const GlobalStyles = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    background-size: cover;
  }

  #root {
    height: 100%;
  }

  button {
    outline: none;
    border: none;
    border-style: none
  }

  input[type=number]::-webkit-inner-spin-button { 
    -webkit-appearance: none;
  }

  p {
    margin: 0;
  }

  #nprogress {
    .bar {
      background-color: ${({ theme }) => theme.token.colorPrimary};
    }

    .bar {
      box-shadow: ${({ theme }) =>
        `0 0 10px ${theme.token.colorPrimary}, 0 0 5px ${theme.token.colorPrimary}`};
    }
  }
`;
